import { Access } from "@p0security/shared/types/access/index";

const generated = {
  until: {
    type: "string",
    label: "Registered expiration time",
  },
} as const;

const gateway = {
  type: "static",
  label: "Gateway",
  description: "Gateway that hosts agentic access",
} as const;

const mcpServer = {
  type: "static",
  label: "MCP server",
  description: "Gateway-hosted MCP server",
} as const;

export const AgenticAccesses = {
  agent: Access({
    label: "Agent",
    description: "Gain the ability to prompt another agent",
    maturity: "ga",
    delegation: {},
    generated,
    parameters: {
      gateway,
      server: {
        type: "static",
        label: "A2A bridge",
        description: "Gateway bridge that brokers access to the agent",
      },
      id: {
        type: "input",
        label: "Agent ID",
        description:
          "Identities of the agents that will be called; these are the paths of the agents relative to their host",
        multivalued: true,
      },
      operation: {
        type: "generated",
        label: "Agent operation",
      },
    },
    render: { locator: "server", policy: "operation", resource: "id" } as const,
  }),
  annotation: Access({
    label: "MCP tool annotation",
    description:
      "Gain access to call tools with matching annotations, on a server",
    maturity: "ga",
    delegation: {},
    generated,
    parameters: {
      gateway,
      server: mcpServer,
      annotation: {
        type: "static",
        label: "Annotation(s)",
        multivalued: true,
      },
    },
    render: {
      locator: "gateway",
      policy: "annotation",
      resource: "server",
    } as const,
  }),
  tool: Access({
    label: "MCP tool",
    description: "Gain access to call tools by name",
    maturity: "ga",
    delegation: {},
    generated,
    parameters: {
      gateway,
      server: mcpServer,
      tool: { type: "static", label: "Tool(s)", multivalued: true },
    },
    render: { locator: "gateway", policy: "tool", resource: "server" } as const,
  }),
};

export type AgenticAccesses = typeof AgenticAccesses;

export type AgenticAccess = AgenticAccesses[keyof AgenticAccesses];

export type AgenticAgentAccess = AgenticAccesses["agent"];
export type AgenticAnnotationAccess = AgenticAccesses["annotation"];
export type AgenticToolAccess = AgenticAccesses["tool"];
